import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getCookie } from "./httpClient";

import { useSelector } from "react-redux";
import Loader from "../components/Loader";

function ExpertProtectedRoute({ children }) {
  const isAuthenticated = getCookie("token");

  const profile = useSelector((store) => store.profile);
  let location = useLocation();
  if (profile?.success == true) {
    if (profile?.data?.expert == null) {
      return (
        <Navigate
          to="/expert-create/become-expert"
          //   state={{ from: location }} replace
        />
      );
    } else if (
      profile?.data?.expert?.applicationStage == "submitted" ||
      profile?.data?.expert?.applicationStage == "rejected"
    ) {
      return (
        <Navigate
          to={`/application-status/expert/${profile?.data?.expert?._id}`}
          //   state={{ from: location }} replace
        />
      );
    } else {
      return children;
    }
  } else {
    return <Loader message="Please wait!!!" />;
  }
}

export default ExpertProtectedRoute;
